// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3TTcF","resendInfoText":"OnGoingPaymentBox_resendInfoText__2UnX_"};